const STATUS_COMPLETE = 'complete';
const STATUS_SUCCESS = 'success';
const STATUS_ERROR = 'error';
const STATUS_WARNING = 'warning';
const STATUS_PROMPT = 'prompt';
const STATUS_ACTION = 'action';
const STATUS_EXCEPTION = 'exception';
const STATUS_REQUEST_DENIED = 'request_denied';

let nope = () => {};

let abstract_callbacks = {
    'complete': nope,
    'success': nope,
    'error': nope,
    'warning': nope,
    'prompt': nope,
    'action': nope,
    'exception': nope,
    'request_denied': nope
};

let ResponseHandler = function(data_received, callback) {
    this.data = null;
    this.callback = abstract_callbacks;
    this.init(data_received, callback);
};

ResponseHandler.prototype = {
    init: function(data_received, callback) {

        this.data = data_received;

        _.each(callback, (item, cb_key) => {
            this.callback[cb_key] = item;
        });

        this.processData();
    },
    processData: function() {
        if(this.data == null || _.isEmpty(this.data)){
            console.log('No data to process');
        } else if(!_.isPlainObject(this.data) || this.data.result == undefined) {
            this.callback[STATUS_SUCCESS](this.data);
        } else {
            let json_data = this.data.data;
            switch(this.data.result) {
                case STATUS_SUCCESS:
                    this.callback[STATUS_SUCCESS](this.data.data || this.data.error);
                    break;
                case STATUS_ERROR:
                    this.callback[STATUS_ERROR](this.data.data || this.data.error || this.data.errors);
                    break;
                case STATUS_WARNING:
                    this.callback[STATUS_WARNING](this.data.data);
                    break;
                case STATUS_ACTION:
                    this.performAction(this.data.data);
                    break;
            }
        }
        this.callback[STATUS_COMPLETE]();
    },
    performAction: function(data) {
        console.log('ResponseHandler.performAction');
        let action_type = data.require_action;
        let actual_action = () => {};
        switch(action_type){
            case 'redirect':
                actual_action = new redirectAction(data);
                break;
            case 'login':
                getApp.$store.dispatch("setRedirectUrl", window.location.pathname + window.location.search);
                actual_action = new loginAction(data);
                break;
            case 'update_available_team':
                actual_action = new UpdateAvailableTeamAction(data);
                break;
        }
        actual_action.execute();
    }
}

let baseAction = function() {
    this.type = "";
    this.init();
};

baseAction.prototype = {
    'init': function() {

    }
};

let redirectAction = function(data) {
    this.base = null;
    this.url = null;
    this.init(data);
};

redirectAction.prototype = {
    'init': function(data) {
        this.base = new baseAction();
        this.base.type = "redirect";
        this.url = data.url;
    },
    'execute': function() {
        window.location.href = this.url;
    }
};

let loginAction = function(data) {
    this.base = null;
    this.url = null;
    this.init(data);
};

loginAction.prototype = {
    'init': function(data) {
        this.base = new baseAction();
        this.base.type = 'login';
    },
    'execute': function() {
        window.getApp.$emit('APP_AUTH_FAILED');
    }
};

let UpdateAvailableTeamAction = function(data) {
    this.base = null;
    this.url = null;
    this.init(data);
};

UpdateAvailableTeamAction.prototype = {
    'init': function(data) {
        this.base = new baseAction();
        this.base.type = 'update_available_team';
    },
    'execute': function() {
        window.location.reload();
    }
};

export default ResponseHandler;